import clsx from "classnames";
import { Container } from "react-bootstrap";

export const Divider = ({ className }) => {
  return (
    <div className={clsx(className)}>
      <Container className="mw-xxl">
        <hr />
      </Container>
    </div>
  );
};

export default Divider;
